<template>
  <div v-if="insurer">
    <slot :insurer="insurer"></slot>
  </div>
</template>

<script>
import { show } from "@/services/public_insurers_service";

export default {
  mixins: [],

  components: {},

  props: {
    insurerSlug: String,
  },

  data() {
    return {
      insurer: null,
    };
  },

  methods: {
    async load() {
      try {
        const response = await show(this.insurerSlug);
        this.insurer = response;
      } catch (error) {
        this.insurer = {
          logo: "default.png",
          color: "primary",
        };
      }
    },
  },

  computed: {},

  created() {
    this.load();
  },
};
</script>
